"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var listview_1 = require("@rainbow-modules/listview");
var styled_1 = require("./styled");
var getNormalizedOption = function (airline) {
    if (airline) {
        var iata = airline.iata, icao = airline.icao, name_1 = airline.name;
        var code = iata || icao;
        var label = '';
        if (code && name_1) {
            label = code + " - " + name_1;
        }
        if (code) {
            label = code;
        }
        if (name_1) {
            label = name_1;
        }
        return {
            label: label,
            airline: airline,
        };
    }
    return null;
};
var getNormalizedOptions = function (options) {
    return options.map(getNormalizedOption);
};
function AirlinesLookup(props) {
    var airlines = props.airlines, onChange = props.onChange, value = props.value, required = props.required;
    var _a = react_1.useState(getNormalizedOptions(airlines.slice(0, 20))), options = _a[0], setOptions = _a[1];
    var search = function (query) {
        if (query.length > 0) {
            var data = listview_1.filterByFields({
                data: airlines,
                query: query,
                fields: ['name', 'iata', 'icao'],
            });
            setOptions(getNormalizedOptions(data.slice(0, 20)));
        }
        else {
            setOptions(getNormalizedOptions(airlines.slice(0, 20)));
        }
    };
    return (react_1.default.createElement(styled_1.StyledLookup, { placeholder: "Select Airline", label: "Select Airline", required: required, labelAlignment: "left", onChange: onChange, value: getNormalizedOption(value), onSearch: search, options: options, debounce: true }));
}
exports.default = AirlinesLookup;
AirlinesLookup.propTypes = {
    airlines: prop_types_1.default.array.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    required: prop_types_1.default.bool.isRequired,
    value: prop_types_1.default.object,
};
AirlinesLookup.defaultProps = {
    value: undefined,
};
//# sourceMappingURL=airlinesLookup.js.map